import { AxiosResponse } from 'axios';

import api from '~/services/api';
import { UserInterface } from '@e3labs/isa-data-dictionary';
import { RoutedClientsReportData } from './routed-clients-report-interface';

class DailyRouteReportServices {
  getListSuccessRoutedClientsReports(
    { skip = 0, limit = 10, ...rest },
    opts?: any
  ): Promise<AxiosResponse<RoutedClientsReportData[] | null>> {
    return api.get('/vendor-client-visit/vendor-client-route-report', {
      params: {
        skip,
        limit,
        ...rest
      },
      ...opts
    });
  }

  getCSVSuccessDailyRouteReports({ ...params }): Promise<AxiosResponse<Blob>> {
    return api.get('/vendor-client-visit/vendor-client-route-report-csv', {
      params: {
        ...params
      },
      responseType: 'blob'
    });
  }

  getSellers(opts?: any): Promise<AxiosResponse<UserInterface[] | null>> {
    return api.get('/user', {
      params: {},
      ...opts
    });
  }
}

export default new DailyRouteReportServices();
